import { FullLogo } from '@c/icons';
import Link from 'next/link';
import React, { useState } from 'react';
import { HiMiniBars3 } from 'react-icons/hi2';
import { RiCloseFill } from 'react-icons/ri';
import MenuDrawer from './MenuDrawer';
import SearchBox from '@ui/SearchBox';

const LandingPageHeader: React.FC = () => {
  const [menuOpen, setMenuOpen] = useState<boolean>(false);

  return (
    <header className="py-6 px-10 bg-white sticky md:relative top-0 z-50">
      <nav className="max-w-[1306px] w-full mx-auto flex items-center justify-between">
        {/* Logo */}
        <div className="hidden lg:flex items-center">
          <Link href="/" aria-label="Home">
            <FullLogo variant="default" width={313.69} height={60} />
          </Link>
        </div>
        <div className="flex lg:hidden items-center">
          <Link href="/" aria-label="Home">
            <FullLogo variant="default" width={214} height={41} />
          </Link>
        </div>

        {/* Desktop Search Bar - Middle of nav */}
        <div className="hidden md:block md:max-w-xl md:flex-1 md:mx-8">
          <SearchBox />
        </div>

        {/* Desktop Nav */}
        <div className="hidden md:flex items-center gap-10">
          <div className="flex items-center gap-10">
            <Link
              href="#popular-now"
              className="text-[18px] font-medium hover:text-[#ED7523] transition-colors duration-300"
            >
              Gear Drops
            </Link>
            <Link
              href="#sell-today"
              className="text-[18px] font-medium hover:text-[#ED7523] transition-colors duration-300"
            >
              Sell Today
            </Link>
            <Link
              href="#faqs"
              className="text-[18px] font-medium hover:text-[#ED7523] transition-colors duration-300"
            >
              FAQs
            </Link>
          </div>

          <Link href="/sell">
            <button className="bg-[#ED7523] text-white py-2 px-6 rounded-[10px] font-semibold text-[16px] hover:bg-[#cf5c12] transition">
              Sell Your Gear
            </button>
          </Link>
        </div>

        {/* Mobile Menu Icon */}
        <div className="md:hidden">
          <button onClick={() => setMenuOpen(!menuOpen)} aria-label="Toggle Menu">
            {menuOpen ? <RiCloseFill size={24} /> : <HiMiniBars3 size={30} />}
          </button>
        </div>
      </nav>

      {/* Mobile Search Bar - Below logo and hamburger */}
      <div className="md:hidden mt-4">
        <SearchBox />
      </div>

      <MenuDrawer show={menuOpen} dismiss={() => setMenuOpen(!menuOpen)} />
    </header>
  );
};

export default LandingPageHeader;
